import {closeDialog} from 'platform/components';

import {useOnMount} from 'shared/web';

export function CloseBulkOperationActionDialog(props: {dialogId: string}) {
  useOnMount(() => closeDialog(props.dialogId));
  return null;
}
